import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from '@nosto/preact';
import { useEffect, useRef, useState } from 'preact/hooks';

export default ({ facet, isCategorySelected }) => {
    const detailsRef = useRef(null);
    const {
        min,
        max,
        range,
        updateRange
    } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1];
    const [show, setShow] = useState(false);
    const defaultClass = 'filter-dropdown-box filter-dropdown-menu border border-gray-300 rounded-lg p-4 absolute top-full start-0 bg-white mt-2 ';
    const [dropdownClasses, setDropdownClasses] = useState('hidden');

    const shouldShowNewSearch = window.cj.nosto.newSearchFeatureEnabled && !isCategorySelected

    const ChevronIcon = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" class="chevron-icon duration-300" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 3.33333L10.6667 8L6 12.6667" stroke="#38BFC3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        )
    }

    // Open up group with selected filters
    useEffect(() => {
        if (detailsRef.current && isSelected) {
            detailsRef.current.open = !shouldShowNewSearch;
        }
        if (show) {
            setDropdownClasses(defaultClass + ' block')
        } else {
            setDropdownClasses('hidden')

        }
    }, [isSelected, show]);

    const menuToggle = () => {
        setShow(!show)
        document.addEventListener('click', (e) => {
            detailsRef.current && !detailsRef.current.contains(e.target) && setShow(false)
        })
    }

    return (
        <>
            {shouldShowNewSearch ? (
                <div class='relative filter-dropdown z-10 cursor-pointer' onClick={() => menuToggle()}>
                    <div
                        ref={detailsRef}
                    >
                        <div class="px-4 py-2 text-sm rounded-lg bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 flex items-center gap-2 shadow-sm">
                            <span class={isSelected ? 'bold-text leading-normal' : 'leading-normal'}>{facet.name}</span>
                            {isSelected &&
                                <span class='leading-normal' >${range[0]} - ${range[1]}</span>
                            }
                            {isSelected ?
                                <div class='mr-1 ml-1' onClick={() => updateRange([min, max])}>
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 9L9 1M1 1L9 9" stroke="#707073" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div> :
                                <div class='mr-1 ml-1' >
                                    <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg" class={`duration-300 ${show ? "rotate-180" : ""}`}>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.234315 0.83429C0.546734 0.521871 1.05327 0.521871 1.36569 0.83429L4 3.4686L6.63432 0.83429C6.94673 0.521871 7.45327 0.521871 7.76569 0.83429C8.0781 1.14671 8.0781 1.65324 7.76569 1.96566L4.56569 5.16566C4.25327 5.47808 3.74673 5.47808 3.43431 5.16566L0.234315 1.96566C-0.0781049 1.65324 -0.0781049 1.14671 0.234315 0.83429Z" fill="#111827" />
                                    </svg>
                                </div>
                            }
                        </div>

                        <div class={dropdownClasses}>
                            <div class="sec-sidebar--container">
                                <div class="app--filters--range-facet filter-range">
                                    <div>
                                        <label for={`ns-${facet.id}-min`}>
                                            Min.
                                        </label>
                                        <input
                                            type="number"
                                            id={`ns-${facet.id}-min`}
                                            value={range[0]}
                                            min={min}
                                            max={max}
                                            onChange={(e) => {
                                                const value = parseFloat(e.currentTarget.value) || undefined;
                                                updateRange([value, range[1]]);
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label for={`ns-${facet.id}-max`}>
                                            Max.
                                        </label>
                                        <input
                                            type="number"
                                            id={`ns-${facet.id}-max`}
                                            value={range[1]}
                                            min={min}
                                            max={max}
                                            onChange={(e) => {
                                                const value = parseFloat(e.currentTarget.value) || undefined;
                                                updateRange([range[0], value]);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <RangeSlider id={facet.id} />
                        </div>
                    </div>
                </div>
            ) : (
                <details
                    class="app--filters-facet"
                    data-nosto-element="facet"
                >
                    <summary class="lg:sec-sidebar--label mobile-sidebar-label">
                        <span>{facet.name}</span>
                        <ChevronIcon />
                    </summary>

                    <div class="sec-sidebar--container">
                        <div class="app--filters--range-facet">
                            <div>
                                <label for={`ns-${facet.id}-min`}>
                                    Min.
                                </label>
                                <input
                                    type="number"
                                    id={`ns-${facet.id}-min`}
                                    value={range[0]}
                                    min={min}
                                    max={max}
                                    onChange={(e) => {
                                        const value = parseFloat(e.currentTarget.value) || undefined;
                                        updateRange([value, range[1]]);
                                    }}
                                />
                            </div>
                            <div>
                                <label for={`ns-${facet.id}-max`}>
                                    Max.
                                </label>
                                <input
                                    type="number"
                                    id={`ns-${facet.id}-max`}
                                    value={range[1]}
                                    min={min}
                                    max={max}
                                    onChange={(e) => {
                                        const value = parseFloat(e.currentTarget.value) || undefined;
                                        updateRange([range[0], value]);
                                    }}
                                />
                            </div>
                        </div>
                        <RangeSlider id={facet.id} />
                    </div>
                </details>
            )
            }
        </>
    )
}
